import { render, staticRenderFns } from "./Whitelabels.vue?vue&type=template&id=2f93de5c&scoped=true&"
import script from "./Whitelabels.vue?vue&type=script&lang=js&"
export * from "./Whitelabels.vue?vue&type=script&lang=js&"
import style0 from "./Whitelabels.vue?vue&type=style&index=0&id=2f93de5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f93de5c",
  null
  
)

export default component.exports